<template>
  <div>
    <div v-if="meta" class="row employee__filtration no-gutters">
      <div class="col-sm-3">
        <span>
          {{ I18n.t('filters.show') }}
          <Filters
            :options="perPage"
            :isShowAllRecordsButtonClicked="isShowAllRecordsButtonClicked"
            @changeSelected="handleSelectChange"
            @allRecordsSelected="() => isShowAllRecordsButtonClicked = !isShowAllRecordsButtonClicked"
          />
        </span>
      </div>
      <div class="col-sm-6">
        <Pagination :meta="meta" class="text-center" />
      </div>
      <div class="col-sm-3 text-right">
        <span>
          {{I18n.t('filters.date.label')}}
          <DropdownFilter :options="futureBoundaryDates" @changeSelected="(value) => selectedFutureBoundaryDate = value" />
        </span>
      </div>
    </div>
    <table class="auctions__table mt-5">
      <thead>
        <tr>
          <th>{{I18n.t("table.number")}}</th>
          <th><SortLink :attribute="'auction_house_name'" :name="'auctions_catalogs.house_name'" @changeQ="(value) => q = value" /></th>
          <th><SortLink :attribute="'name'" :name="'auctions_catalogs.auction_name'" @changeQ="(value) => q = value" /></th>
          <th>{{I18n.t("auctions_catalogs.city")}}</th>
          <th><SortLink :attribute="'start_date'" :name="'auctions_catalogs.start_date'" @changeQ="(value) => q = value" /></th>
          <th></th>
          <th><SortLink :attribute="'orders_count'" :name="'auctions_catalogs.orders_count'" @changeQ="(value) => q = value" /></th>
        </tr>
      </thead>
      <tbody>
        <AuctionsCatalogsRow
          v-for="(id, index) in result"
          :auctionsCatalog="auctionsCatalogs[id]"
          :address="auctionsCatalogs[id].address"
          :auctionHouse="auctionsCatalogs[id].auctionHouse"
          :index="index"
          :key="index"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
  import { schema, normalize } from 'normalizr';
  import SortLink from '@/shared/components/sort_link';
  import Pagination from '@/shared/components/pagination/index';
  import DropdownFilter from '@/shared/components/dropdown_filter';
  import Filters from '@/shared/components/filters';
  import dataFormatter from '@/shared/data_formatter';
  import { FIRST_PAGE, DEFAULT_PER_PAGE } from '@/shared/consts';
  import { FUTURE_BOUNDARY_DATES, PER_PAGE } from './../../consts';
  import AuctionsCatalogsRow from './row';

  export default {
    data() {
      return {
        auctionsCatalogs: {},
        meta: null,
        auctionsCatalogsCount: 0,
        result: [],
        perPage: PER_PAGE,
        futureBoundaryDates: FUTURE_BOUNDARY_DATES,
        selectedPerPage: DEFAULT_PER_PAGE,
        selectedFutureBoundaryDate: null,
        isShowAllRecordsButtonClicked: false,
        selectedPer: DEFAULT_PER_PAGE,
        q: null,
        fetchTimeout: null,
      };
    },
    created() {
      this.fetchAuctionsCatalogs();
    },
    name: 'AuctionsCatalogsList',
    components: {
      AuctionsCatalogsRow,
      Pagination,
      SortLink,
      DropdownFilter,
      Filters,
    },
    watch: {
      filterParams() {
        const buildQuery = this.$route.query || {};
        buildQuery.page = FIRST_PAGE;
        this.$router.replace({ query: buildQuery });
        this.fetchAuctionsCatalogs();
      },
      currentPage() {
        this.filterParams.page = this.currentPage.page;
        this.fetchAuctionsCatalogs();
      },
      isShowAllRecordsButtonClicked(val) {
        if (val) {
          this.selectedPer = this.meta.total_count;
        } else {
          this.selectedPer = this.selectedPerPage;
        }
      },
      selectedPerPage() {
        this.selectedPer = this.selectedPerPage;
      },
    },
    computed: {
      filterParams() {
        return {
          per: this.selectedPer,
          future_dates_range: [this.selectedFutureBoundaryDate],
          q: this.q,
        };
      },
      currentPage() {
        return {
          page: this.$route.query.page || FIRST_PAGE,
        };
      },
    },
    methods: {
      fetchAuctionsCatalogs() {
        clearTimeout(this.fetchTimeout);
        this.fetchTimeout = setTimeout(() => {
          this.$http.get(`/api/v1/${this.$route.path}`, { params: this.filterParams }).then((response) => {
            this.auctionsCatalogs = normalize(dataFormatter.deserialize(response.body), [new schema.Entity('auctionsCatalogs')]).entities.auctionsCatalogs;
            this.result = normalize(dataFormatter.deserialize(response.body), [new schema.Entity('auctionsCatalogs')]).result;
            this.meta = response.body.meta;
            this.auctionsCatalogsCount = this.meta.total_count;
          }, () => {});
          return this.auctionsCatalogs;
        }, 200);
      },
      handleSelectChange(value) {
        this.selectedPerPage = value;
        this.isShowAllRecordsButtonClicked = false;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/auctions_catalogs/index/components/auctions_catalogs/list.vue?41a72114